import { ErrorMessage, Field, Formik, Form } from 'formik';
import React, { useState } from 'react';
import { createActionSettingsSchema, getFieldInfoByName } from './Util';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import CustomLoader from '../../../common/CustomLoader';
import { FieldTypes } from 'drapcode-constant';
import { iconForField } from '../../../../common/custom/icon-library';
import TooltipInfo from '../../../../common/docs/TooltipInfo';
import BrowserStorageOptions from '../BrowserStorageOptions';
import ConsoleLogOptions from '../../ConsoleLogOptions';

export const CollectionItemWithReferenceItemForm = ({
  projectId,
  selectedEvent,
  eventAction,
  actionData,
  events,
  actions,
  hideModal,
  showLoaderForAction,
  version,
}) => {
  const [showBSLOption, setShowBSLOption] = useState(false);
  const [showCLOption, setShowCLOption] = useState(false);

  const collectionOptions = () => {
    let options = [{ value: '', label: 'Choose Collection' }];
    let collections = events ? events.collections : [];
    if (collections.length > 0) {
      options = options.concat(
        collections.map((collection) => {
          return { value: collection.collectionName, label: collection.collectionTitle };
        }),
      );
    }
    return options;
  };

  const collectionReferenceFieldsOptions = (values) => {
    let options = [{ value: '', label: 'Choose Field' }];
    let collections = events ? events.collections : [];
    let collectionName = values['collection'] ? values['collection'] : '';
    if (collections.length > 0) {
      const collection = collections.find((coll) => coll.collectionName === collectionName);
      if (collection && collection.fields) {
        const collectionFields = collection.fields
          ? collection.fields.filter(
              (e) =>
                FieldTypes.reference.id === e.type &&
                !e.type !== FieldTypes.createdBy.id &&
                e.fieldName !== 'tenantId',
            )
          : [];
        options = options.concat(
          collectionFields.map((field) => {
            if (field.fieldName) {
              const value =
                field.refCollection && field.refCollection.collectionName
                  ? `${field.fieldName}:${field.refCollection.collectionName}`
                  : '';
              return {
                value,
                label: field.fieldTitle.en,
              };
            }
          }),
        );
      }
    }
    return options;
  };

  const constructorOptions = (values) => {
    let options = [{ value: '', label: 'Choose Constructor' }];
    let collections = events ? events.collections : [];
    let collectionName = values['collection'] ? values['collection'] : '';
    const selectedCollection = collections.find(
      (collection) => collection.collectionName === collectionName,
    );
    let constructors = selectedCollection ? selectedCollection.constructors : [];
    if (constructors.length > 0) {
      options = options.concat(
        constructors.map((constructor) => {
          return { value: constructor.uuid, label: constructor.customConstructorName };
        }),
      );
    }
    return options;
  };

  const handleSubmit = (values) => {
    let parameters = [];
    Object.keys(values).map((value) => {
      const action = actionData.args.find((param) => {
        return param.name === value;
      });
      parameters.push({ name: value, value: values[value], type: action.type });
    });

    let actionFormData = eventAction;
    actionFormData.parameters = parameters;
    actions.updateAction({
      projectId,
      version,
      eventId: selectedEvent.uuid,
      data: actionFormData,
    });
    hideModal();
  };

  const bslOptionHandler = () => {
    setShowBSLOption(!showBSLOption);
  };

  const clogOptionHandler = () => {
    setShowCLOption(!showCLOption);
  };

  const browserStorageLocationOptions = () => {
    let options = [
      { value: 'SESSION_STORAGE', label: 'Session Storage (Default)' },
      { value: 'LOCAL_STORAGE', label: 'Local Storage' },
      { value: 'COOKIES', label: 'Cookies' },
    ];
    return options;
  };

  const validateFormDataSessionKey = (value) => {
    let error;
    if (!value) {
      error = "Form Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Form Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Form Data Session Key can not be more than 50 characters';
    }
    return error;
  };
  const validateResponseDataSessionKey = (value) => {
    let error;
    if (!value) {
      error = "Response Data Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Response Data Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Response Data Session Key can not be more than 50 characters';
    }
    return error;
  };
  const validateReferenceItemSessionKey = (value) => {
    let error;
    if (!value) {
      error = "Reference Item Session Key can't be blank";
    } else if (!/^[^_][A-Za-z_0-9]+$/i.test(value)) {
      error = 'Reference Item Session Key should not contain special characters';
    } else if (value.length > 50) {
      error = 'Reference Item Session Key can not be more than 50 characters';
    }
    return error;
  };

  return (
    <Formik
      enableReinitialize={true}
      initialValues={createActionSettingsSchema(actionData, eventAction)}
      onSubmit={(values, { setSubmitting, resetForm }) => {
        handleSubmit(values);
      }}
    >
      {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
        <Form>
          <div className="row">
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Collection"
                  icon="select"
                  infoIcon={true}
                  infoDescription={'Select Collection which you want to Create Item For.'}
                >
                  <CustomSelect
                    name={'collection'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={collectionOptions()}
                    value={values['collection']}
                  />
                  <ErrorMessage name={'collection'}>
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Constructor"
                  icon="select"
                  infoIcon={true}
                  infoDescription={'Select Collection Constructor.'}
                >
                  <CustomSelect
                    name={'constructor'}
                    isMulti={false}
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    options={constructorOptions(values)}
                    value={values['constructor']}
                  />
                  <ErrorMessage name={'collection'}>
                    {(msg) => <p className="text-error">{msg}</p>}
                  </ErrorMessage>
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="form-group">
              <div className="col-12">
                <FormFieldWithLabel
                  cta={false}
                  label=""
                  icon="boolean-toggle"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('createReferenceFields')}
                >
                  <div className="form-check">
                    <label className="form-check-label">
                      <Field
                        type="checkbox"
                        name="createReferenceFields"
                        className="form-check-input"
                        title="createReferenceFields"
                      />
                      Do you want to Create Empty Reference items ?
                      <span className="form-check-sign">
                        <span className="check"></span>
                      </span>
                    </label>
                    <ErrorMessage name="createReferenceFields">
                      {(msg) => <p className="text-error">{msg}</p>}
                    </ErrorMessage>
                  </div>
                </FormFieldWithLabel>
              </div>
            </div>
            {values['collection'] && values['createReferenceFields'] ? (
              <>
                <div className="col-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label="Reference Field"
                      icon="select"
                      infoIcon={true}
                      infoDescription={getFieldInfoByName('collectionRefFields')}
                    >
                      <CustomSelect
                        name={'collectionRefFields'}
                        isMulti={true}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        options={collectionReferenceFieldsOptions(values)}
                        value={values['collectionRefFields']}
                      />
                    </FormFieldWithLabel>
                  </div>
                </div>
              </>
            ) : (
              ''
            )}
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Success Message"
                  icon="text"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('successMessage')}
                >
                  <Field
                    name="successMessage"
                    type="text"
                    placeholder="(Optional) Enter custom success message."
                    className="form-control form-control-sm"
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <FormFieldWithLabel
                  cta={false}
                  label="Error Message"
                  icon="text"
                  infoIcon={true}
                  infoDescription={getFieldInfoByName('errorMessage')}
                >
                  <Field
                    name="errorMessage"
                    type="text"
                    placeholder="(Optional) Enter custom error message."
                    className="form-control form-control-sm"
                  />
                </FormFieldWithLabel>
              </div>
            </div>
            <div className="col-12">
              <div className="form-group">
                <button
                  onClick={(e) => bslOptionHandler(e)}
                  className="btn btn-icon-only btn-outline-info ml-5 p-1"
                  title="Show Browser Storage Options"
                  type="button"
                >
                  <i className="wb webconnect-cog"></i>&nbsp;Browser Storage Options
                </button>
                <button
                  onClick={(e) => clogOptionHandler(e)}
                  className="btn btn-icon-only btn-outline-info ml-2 p-1"
                  title="Show Console Log Options"
                  type="button"
                >
                  <i className="wb webconnect-cog"></i>&nbsp;Console Log Options
                </button>
              </div>
              {showBSLOption && (
                <BrowserStorageOptions
                  values={values}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  validateFormDataSessionKey={validateFormDataSessionKey}
                  validateResponseDataSessionKey={validateResponseDataSessionKey}
                  validateRefItemDataSessionKey={validateReferenceItemSessionKey}
                  saveRefItemIdInBrowserSession={true}
                />
              )}
              {showCLOption && <ConsoleLogOptions values={values} />}
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 text-left">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={hideModal}
              >
                <span>
                  <i className="wb webconnect-times"></i>&nbsp;Cancel
                </span>
              </button>
            </div>
            <div className="col-md-6 text-right">
              <button type="submit" className="btn btn-theme-submit btn-sm">
                <i className="wb webconnect-save-regular"></i>&nbsp;Save&nbsp;
                <CustomLoader loading={showLoaderForAction} />
              </button>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};
